const UpdateCMS = () => {};
export default UpdateCMS;
